import { render, staticRenderFns } from "./searchPage.vue?vue&type=template&id=a3f956a2&scoped=true"
import script from "./searchPage.vue?vue&type=script&lang=js"
export * from "./searchPage.vue?vue&type=script&lang=js"
import style0 from "./searchPage.vue?vue&type=style&index=0&id=a3f956a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f956a2",
  null
  
)

export default component.exports